<div class="picture-container">
  <div *ngIf="picture" class="picture" (click)="updatePicture()">
    <img alt="{{ 'id_photo' | translate }}" [src]="picture | safe" />
  </div>
  <div class="actions">
    <button mat-stroked-button color="primary" type="button" (click)="updatePicture()" [disabled]="disable">
      <mat-icon [svgIcon]="picture ? 'rotate-right' : 'card-account-details'"></mat-icon>
      <span *ngIf="picture; else noPicture">{{ editPictureLabel }}</span>
      <ng-template #noPicture>{{ addPictureLabel }}</ng-template>
    </button>
  </div>
</div>
